import React from "react";

import StateMachine from "../utils/StateMachine";

import StepDetails from "./StepDetails_1st";
import StepVerification from "./StepVerification_2nd";
import StepAboutYou from "./StepAboutYou";
import StepSkills from "./StepSkills_3rd";
import StepInstagram from "./StepInstagram_4th";
import StepPhotos from "./StepPhotos_5th";
import Success from "./Success";
import { withRouter } from "react-router-dom";

class TalentApplication extends React.Component {
  render() {
      const { pathname } = this.props.location;
      const validPaths = [
          "/apply",
          "/apply/verification",
          "/apply/personal",
          "/apply/skills",
          "/apply/instagram",
          "/apply/photos",
          "/apply/complete",
      ];

      if (!validPaths.includes(pathname)) {
          this.props.history.replace("/apply");
      }
    return (
      <StateMachine.State is="apply">
        <StateMachine.Consumer>
          {() => {
              return (
                <React.Fragment>
                  <StateMachine.State is="apply.details">
                      <StepDetails/>
                  </StateMachine.State>
                  <StateMachine.State is="apply.verification">
                      <StepVerification/>
                  </StateMachine.State>
                  <StateMachine.State is="apply.personal">
                      <StepAboutYou/>
                  </StateMachine.State>
                  <StateMachine.State is="apply.skills">
                    <StepSkills />
                  </StateMachine.State>
                    <StateMachine.State is="apply.instagram">
                        <StepInstagram />
                    </StateMachine.State>
                    <StateMachine.State is="apply.selectInstagramPhotos">
                        <StepPhotos />
                    </StateMachine.State>
                  <StateMachine.State is="apply.complete">
                    <Success />
                  </StateMachine.State>
                </React.Fragment>
              );
          }}
        </StateMachine.Consumer>
      </StateMachine.State>
    );
  }
}

export default withRouter(TalentApplication);